import { Controller } from "@hotwired/stimulus";
import * as ReactDOMClient from "react-dom/client";

// No-op root returned during Turbo preview pages to avoid rendering React
// components that will be immediately torn down when the fresh response arrives.
const NOOP_ROOT = Object.freeze({ render() {}, unmount() {} });

export class ReactController extends Controller {
  static values = {
    props: Object,
  };

  get root() {
    // During a Turbo preview (cached snapshot), skip React rendering entirely.
    // The fresh server response will arrive momentarily and mount a real root.
    // Without this, users see: content (preview) → flash → skeleton → content.
    if (document.documentElement.hasAttribute("data-turbo-preview")) {
      return NOOP_ROOT;
    }

    if (this._root === undefined) {
      this._root = ReactDOMClient.createRoot(this.element);
    }
    return this._root;
  }

  disconnect() {
    if (this._root) {
      this._root.unmount();
      this._root = undefined; // Clear cached root so a fresh one is created on reconnect
    }
  }
}
